import styled from "styled-components";

const LogoContainer = styled.div`
  border: 1px solid #dedede;
  border-radius: 100%;
  overflow: hidden;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
`;

const Logo = styled.div`
  width: 100%;
  height: 100%;
  background: url(${(props) => props.url});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
`;

const CompanyLogo = ({ url, size, style }) => {
  return (
    <LogoContainer size={size} style={style}>
      <Logo url={url} />
    </LogoContainer>
  );
};

export default CompanyLogo;
